import React from "react";
import { DualAxes } from "@ant-design/plots";
import { Box, makeStyles } from "@material-ui/core";

const ChartStatisticFrequency = ({ listFrequency }) => {
  const useStyles = makeStyles({
    container: {
      background: "#FFF",
      boxShadow: "0px 0px 4px 0px #8A8A8A4D",
      padding: "16px",
      "& > h1": {
        color: "#08090D",
        fontSize: 22,
        fontWeight: 600,
        marginBottom: 20,
      },
    },
  });
  const classes = useStyles();

  const mapData = (data, name) => {
    const mappedData = [];
    data?.repeatationCount.forEach((item) => {
      const monthName = `Tháng ${item.month}`;
      mappedData.push({
        month: monthName,
        value: Number(item?.repeatationCount) || 0,
        name,
        type: name === 'Tổng số trại lặp' ? 'column' :'line'
      });
    });

    return mappedData;
  };

  const columnData = mapData(
    listFrequency.find((x) => x.farmName === "Tổng số trại lặp"),
    "Tổng số trại lặp"
  );
  const lineData = mapData(
    listFrequency.find((x) => x.farmName === "Tần suất trung bình"),
    "Tần suất trung bình"
  );
  
  const calcPercentWithPrevMonth = (data) => {
    if (data.month === "Tháng 1") return "";
    const findDataPrevMonth = lineData?.find((x) => {
      return (
        Number(data.month.replace("Tháng ", "")) -
          Number(x.month.replace("Tháng ", "")) ===
          1 && x.name === data.name
      );
    });
    const percentPrev =
      Number(findDataPrevMonth.value) - Number(data.value);

    return `<div style="display: flex; align-items: center"><p>${
      percentPrev < 0
        ? '<span style="display: inline-block; font-size: 20px; color: #00ff33">↑</span> Tăng'
        : '<span style="display: inline-block; font-size: 20px; color: #fa0000">↓</span> Giảm'
    }<span > ${Math.abs(percentPrev).toFixed(
      2
    )}% so với tháng trước </span></p></div>`;
  };
  const config = {
    data: [columnData, lineData],
    height: 600,
    xField: "month",
    yField: ["value"],
    legend: {
      position: "bottom",
      offsetY: 10,
      itemName: {
        formatter: (text, item, index) => {
          return index === 0 ? "Tổng trại lặp lại" : "Tần suất trung bình";
        },
      },
    },
    tooltip: {
      shared: false,
      showMarkers: true,

      customContent: (title, items) => {
        return `<div style="padding: 10px;">
                      <h4>${title}</h4>
                      ${items
                        .map((item) =>
                          item.data.type === "line"
                            ? `<div><p style="margin-top: 15px;font-size: 24px">${
                                item.value
                              }%</p> <div>${calcPercentWithPrevMonth(
                                item.data
                              )}</div></div>`
                            : `<div>
                              <div>
                               <p style="font-size: 20px; margin-bottom:12px">Tổng trại lặp lại </p>
                               <div style="display:flex; align-items:center">
                               <div style="width:18px; height:18px; border-radius: 4px; margin-right: 5px; background-color:#0E42D2"></div>
                               <p style="font-size: 20px; margin:0px">${item.value}</p>
                               </div>
                              </div>
                            </div>`
                        )
                        .join("")}
                    </div>`;
      },
    },

    geometryOptions: [
      {
        geometry: "column",
      },
      {
        geometry: "line",
        lineStyle: {
          lineWidth: 2,
          stroke: "#F65C00",
        },
      },
    ],
  };
  return (
    <Box className={classes.container}>
      <h1>Tần suất kiểm tra lặp lại trong năm</h1>
      <DualAxes {...config} />
    </Box>
  );
};

export default ChartStatisticFrequency;
